
import Maori from '../img/maori.svg';
import PMN from '../img/PMN_2.svg';


const Credit = () =>{
    return(
        <div className="credits-container">
        <div className="credits-container--box">
            <div className="credits-container--box---each">
            <p className="credits-container--box---eachperson">Animators&nbsp;&mdash;&nbsp;<b>Hingyi Khong, Lena Lam</b></p>
            <p className="credits-container--box---eachperson">Presenters&nbsp;&mdash;&nbsp;<b>Malcolm Andrews, Jehan Casinader, Chelsea Cuthers-Munro, Roxie&#160;Mohebbi</b></p>
            <p className="credits-container--box---eachperson">Kaiwhakamāori &#40;Translator&#41;&nbsp;&mdash;&nbsp;<b>Zeb Tamihana Nicklin</b></p>
            <p className="credits-container--box---eachperson">Translator &#40;Samoan and Tongan&#41;&nbsp;&mdash;&nbsp;<b>Centre for Pacific Languages</b></p>
            <p className="credits-container--box---eachperson">Design&nbsp;&mdash;&nbsp;<b>Ella Bates-Hermans, Kathryn George</b></p>
            <p className="credits-container--box---eachperson">Layout and development&nbsp;&mdash;&nbsp;<b>Sungmi Kim</b></p>
            </div>
            <div className="credits-container--box---each">
            <p className="credits-container--box---eachperson">Reporters&nbsp;&mdash;&nbsp;<b>Ged Cann, Michelle Duff, Dileepa Fonseka, Jos Franks, Chris Hyde, Kirsty Johnston, Katie Kenny, Florence Kerr, Nikki Macdonald, Hannah Martin, Sapeer Mayron, Glenn McConnell, Cecile Meier, Charlie Mitchell, Olivia Shivas, Ethan Te Ora, Rachel Thomas, Torika Tokalau, Steven Walton</b></p>
            <p className="credits-container--box---eachperson">Social media&nbsp;&mdash;&nbsp;<b>Brittney Deguara, Ellie Ritchie</b></p>
            <p className="credits-container--box---eachperson">Digital production&nbsp;&mdash;&nbsp;<b>Kirsty Allen, Noreen Wong</b></p>
            </div>
            <div className="credits-container--box---each">
            <p className="credits-container--box---eachperson">Editors&nbsp;&mdash;&nbsp;<b>Kelly Dennett, Keith Lynch, Kate Newton, Laura Walters</b></p>

            <p className="credits-container--box---eachperson">Chief Reporter&nbsp;&mdash;&nbsp;<b>Katie Kenny</b></p>
            <p className="credits-container--box---eachperson">Project Director&nbsp;&mdash;&nbsp;<b>John Hartevelt</b></p>
            </div>
            <div className="credits-container--partnerbox">
                <p className="credits-container--partnerbox---title">Made in partnership with</p>
                <div>
                    <a href="https://www.maoritelevision.com/" top="_target">
                        <img src={Maori} alt="Māori Television logo" />
                    </a>
                    <a href="https://pacificmedianetwork.com/stations/pmn-news" top="_target">
                        <img src={PMN} alt="Māori Television logo" />
                    </a>
                </div>
            </div>
        </div>
        
    </div>
    )
}

export default Credit